/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Publish_FailedInputs */

const cs_workflow_publish_failed = /** @type {(inputs: Workflow_Publish_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow se nepodařilo publikovat`)
};

const en_workflow_publish_failed = /** @type {(inputs: Workflow_Publish_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not publish the workflow`)
};

/**
* | output |
* | --- |
* | "Could not publish the workflow" |
*
* @param {Workflow_Publish_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_publish_failed = /** @type {((inputs?: Workflow_Publish_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Publish_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_publish_failed(inputs)
	return cs_workflow_publish_failed(inputs)
});